import MatchResultsView from "../MatchResultsView";
import Navigation from "../../../components/Navigation/Navigation";
import {Navigate, Route, Routes, useParams} from "react-router-dom";

const View = () => {
    const { round, category } = useParams();
    const [ gender, distance ] = category.split("-distance");

    const matchTypeMap = {
        "individual_preliminaries": "PRE",
        "individual_round16": "16",
        "individual_round8": "8",
        "individual_round4": "4",
        "individual_round3": "3",
        "individual_round2": "2"
    };

    const subTitleMap = {
        "145": "Kungdo",
        "90": "TarscaShild",
        "70": "Puta",
        "30": "Zamby"
    };

    // 컬러 표시
    const topRankCountMap = {
        "individual_preliminaries": "16",  // 예선 -> 16강
        "individual_round16": "8",         // 16강 -> 8강
        "individual_round8": "4",          // 8강 -> 4강
        "individual_round4": "2",          // 4강 -> 결승
        "individual_round3": "1",          // 3/4위전 -> 3위
        "individual_round2": "1"           // 결승 -> 우승
    };

    return (
        <MatchResultsView
            matchType={matchTypeMap[round]}
            event={distance}
            gender={gender}
            subTitle={subTitleMap[distance]}
            topRankCount={topRankCountMap[round]}
        />
    );
};

const Individual = () => {
    const { round } = useParams();

    const tabs = [
        { path: "m-distance145", label: "M_145M(Kungdo)" },
        { path: "m-distance90", label: "M_90M(TarscaShild)" },
        { path: "m-distance70", label: "M_70M(Puta)" },
        { path: "m-distance30", label: "M_30M(Zamby)" },
        { path: "f-distance145", label: "F_145M(Kungdo)" },
        { path: "f-distance90", label: "F_90M(TarscaShild)" },
        { path: "f-distance70", label: "F_70M(Puta)" },
        { path: "f-distance30", label: "F_30M(Zamby)" },
    ];

    return (
        <>
            <Navigation
                tabs={tabs}
                basePath={`/match-results/${round}`}
                variant="tab"
            />

            <Routes>
                <Route path="/" element={<Navigate to="m-distance145" replace />} />
                <Route path=":category" element={<View />} />
            </Routes>
        </>
    );
};
export default Individual;
